import { render } from "./TDBG18.vue?vue&type=template&id=4791252d&scoped=true"
import script from "./TDBG18.vue?vue&type=script&lang=js"
export * from "./TDBG18.vue?vue&type=script&lang=js"

import "./TDBG18.vue?vue&type=style&index=0&id=4791252d&lang=css"
import "./TDBG18.vue?vue&type=style&index=1&id=4791252d&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4791252d"]])

export default __exports__